import { ld } from "@/lib/theme/light-dark";
import { type ReactNode, forwardRef } from "react";

type HeroDemoCursorIconProps = {
  readonly size?: number;
};

/** Shared pointer glyph — matches the animated feature-chip demo cursor. */
export const HeroDemoCursorIcon = forwardRef<
  SVGSVGElement,
  HeroDemoCursorIconProps
>(function HeroDemoCursorIcon(props, ref): ReactNode {
  const size: number = props.size ?? 25;
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className="mkhero-demo-cursor-svg"
      aria-hidden
    >
      <path
        d="M4 2 L4 18.5 L8.4 14.3 L11.1 20.2 L14 18.9 L11.3 13 L17.4 13 Z"
        fill={ld("#ffffff", "#181b1f")}
        stroke={ld("#0B0F19", "#fafafa")}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </svg>
  );
});
